<template>
  <div class="tw-flex tw-gap-4">
    <b>Имате промокод? Въведете го тук:</b>

    <div
      class="tw-flex tw-gap-4 promo-code-box-wrapper"
      v-if="!showSuccessAlert"
    >
      <v-text-field
        class="relative"
        v-model="promoCode"
        @input="promoCodeError = ''"
        :error-messages="promoCodeError"
      ></v-text-field>

      <v-btn
        color="primary"
        @click="applyPromoCode"
      >
        Приложи
      </v-btn>
    </div>

    <v-alert
      v-if="showSuccessAlert"
      type="success"
    >
      Промокодът е приложен успешно! Моля изберете метод на плащане от опциите.
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'PromoCodeBox',
  props: {
    event: {
      type: Object,
      required: true,
    },
    secret: {
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    amount: {
      required: true,
    },
    selectedTickets: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      promoCode: '',
      promoCodeError: [],
      showSuccessAlert: false,
    }
  },
  methods: {
    applyPromoCode() {
      if (!this.promoCode) {
        this.promoCodeError = 'Моля въведете промокод'
        return
      }

      axios
        .post(`/events/${this.event.id}/promo-codes/apply`, {
          promo_code: this.promoCode,
          secret: this.secret,
        })
        .then((response) => {
          this.$emit('promo-code-applied', response.data)
          this.showSuccessAlert = true
        })
        .catch((error) => {
          this.promoCodeError = error.response.data.message
        })
    },
  },
}
</script>

<style scoped>
.promo-code-box-wrapper {
  display: flex;
  gap: 1rem;
  max-width: 420px;
  justify-content: center;
  align-items: center;
}

.relative {
  position: relative;
}
</style>
